import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'components.UsageChainModal.title',
    defaultMessage: 'Usage Chain',
  },
  baseUsage: {
    id: 'components.UsageChainModal.baseUsage',
    defaultMessage: 'Base Usage',
  },
  notSet: {
    id: 'components.UsageChainModal.notSet',
    defaultMessage: 'Not Set',
  },
  extension: {
    id: 'components.UsageChainModal.extension',
    defaultMessage: 'Extension',
  },
  started: {
    id: 'components.UsageChainModal.started',
    defaultMessage: 'Started',
  },
  media: {
    id: 'components.UsageChainModal.media',
    defaultMessage: 'Media',
  },
  territoryMarket: {
    id: 'components.UsageChainModal.territoryMarket',
    defaultMessage: 'Territory/Market',
  },
  airingTime: {
    id: 'components.UsageChainModal.airingTime',
    defaultMessage: 'Airing Time',
  },
})
